
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { themes, Invert, Split, SplitRight, Horizontal } from 'mdx-deck'
import pic01 from './images/01.png'
import pic02 from './images/02.jpeg'
import pic03 from './images/03.jpeg'
import pic04 from './images/04.png'
import pic05 from './images/05.jpeg'
import pic06 from './images/06.png'
import pic07 from './images/07.jpeg'
import pic08 from './images/08.jpeg'
import pic09 from './images/09.jpeg'
import pic10 from './images/10.jpeg'
import pic11 from './images/11.png'
import pic12 from './images/12.jpeg'
import pic13 from './images/13.jpeg'
import pic14 from './images/14.jpeg'
import pic15 from './images/15.png'
import pic17 from './images/17.jpeg'
export const theme = themes.future;

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Invert mdxType="Invert">
      <h1>{`相册中的金数据`}</h1>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <img src={pic01} />
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <h2>{`2017.08.03~2018.08.03`}</h2>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic09} />
        <h2>{`入职`}</h2>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic15} />
        <h2>{`INDIVIDUAL CONTRIBUTOR`}</h2>
        <h3>{`#GOKU`}</h3>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <SplitRight mdxType="SplitRight">
        <img src={pic03} />
        <h2>{`换办公室`}</h2>
      </SplitRight>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic05} />
        <h2>{`上架企业微信`}</h2>
        <h3>{`#GOTEN`}</h3>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic06} />
        <h2>{`咖啡馆写代码`}</h2>
        <h3>{`#GOKU`}</h3>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <SplitRight mdxType="SplitRight">
        <img src={pic04} style={{
          height: '100vh'
        }} />
        <h2>{`经常搞乱样式`}</h2>
        <h3>{`#GOKU`}</h3>
      </SplitRight>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic02} />
        <h2>{`然后就离职了`}</h2>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <h2>{`2021.02.01~`}</h2>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Horizontal mdxType="Horizontal">
        <div style={{
          padding: '1em'
        }}>
          <img src={pic08} />
        </div>
        <div style={{
          padding: '1em'
        }}>
          <img src={pic12} />
        </div>
        <div style={{
          padding: '1em'
        }}>
          <img src={pic13} />
        </div>
        <h2>{`🐱 🧑‍💻 💻`}</h2>
      </Horizontal>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <SplitRight mdxType="SplitRight">
        <img src={pic11} />
        <h2>{`HELP THE TEAM GROW`}</h2>
      </SplitRight>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic10} />
        <h2>{`代表团队参加技术活动`}</h2>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic14} />
        <h2>{`与外界建立联系`}</h2>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <SplitRight mdxType="SplitRight">
        <img src={pic17} />
        <h2>{`与团队一起 HAPPY HAKCING`}</h2>
      </SplitRight>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <Split mdxType="Split">
        <img src={pic07} />
        <h2>{`HAVE FUN`}</h2>
      </Split>
    </Invert>
    <hr></hr>
    <Invert mdxType="Invert">
      <h1>{`∞`}</h1>
    </Invert>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;